<template>
    <div class="container">
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657611850522.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657611858828.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657611865928.png">
        </div>
        <div class="section-wrap">
            <div class="section">
                <img class="img" src="https://s21.lgstatic.com/growth/activity/20220712/1657611872297.png">
            </div>
            <div class="tab-section">
                <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657619413388.png">
                <div class="main">
                    <div class="_tb">
                        <el-tabs v-model="activeName" @tab-click="changeTab">
                        <el-tab-pane class="main-tab"
                            v-for="(item, index) in (tabMain.stageList || [])" :key="index"
                            :label="item.stage" :name="index"
                        >
                            <div class="m">
                                <div class="main-wrap">
                                    <div class="m-title">
                                        {{item.title}}
                                    </div>
                                    <img class="main-icon" src="https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png">
                                    <div class="main-t">
                                        <div class="m-b">
                                            学习目标
                                        </div>
                                    </div>
                                    <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" > {{v}}</div>
                                    <div class="main-t">
                                        <div class="m-b">
                                            内容提炼
                                        </div>
                                    </div>
                                    <div class="item-wrap">
                                        <div class="left">
                                            <div class="item" v-for="(v, i) in item.skillsList.left" :key="i" > {{v}}</div>
                                        </div>
                                        <div class="right">
                                            <div class="item" v-for="(v, i) in item.skillsList.right" :key="i" > {{v}}</div>
                                        </div>
                                    </div>
                                    <div v-if="item.tips.length" class="main-t">
                                        <div class="m-b">
                                            实战应用
                                        </div>
                                    </div>
                                    <template v-if="item.tips.length" >
                                        <div class="item" v-for="(v, i) in item.tips" :key="i" > {{v}}</div>
                                    </template>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="modal" v-if="showModal">
                        <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                        <div v-for="(item, index) in showData.details" :key="index">
                            <div class="modal-title">
                                {{item.t}}
                            </div>
                            <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                                {{i}}
                            </div>
                        </div>
                    </div>


                        <span class="remark">【具体课程内容以实际课程安排和进度为准】</span>
                        <button class="stage-more" @click="JumpFn('领取完整课程安排')">
                            <img src="https://s20.lgstatic.com/growth/activity/20220712/1657612337733.png">
                        </button>
                    </div>

                </div>
            </div>
            <div class="section">
                <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657611989153.png">
            </div>
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220712/1657611916489.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657611926356.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220712/1657611934755.png">
        </div>

        <!-- <div class="tab-section">
            <div class="main">
                <img class="tab-title-img" :src="tabMain.pctitleImg">
                <div class="_tb">


                    <el-tabs v-model="activeName" @tab-click="changeTab">
                    <el-tab-pane class="main-tab"
                        v-for="(item, index) in (tabMain.stageList || [])" :key="index"
                        :label="item.stage" :name="index"
                    >
                        <div class="m">
                            <div class="m-title">
                                {{item.title}}
                            </div>
                            <img class="main-icon" src="https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png">
                            <div class="main-t">
                                <div class="m-b">
                                    学习目标
                                </div>
                                <img @click="showModalFn(item)" class="detail" src="https://s21.lgstatic.com/growth/activity/20210817/1629166722545.png">
                            </div>
                            <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" > {{v}}</div>
                            <div class="main-t">
                                <div class="m-b">
                                    内容提炼
                                </div>
                            </div>
                            <div class="item" v-for="(v, i) in item.skillsList" :key="i" > {{v}}</div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="modal" v-if="showModal">
                    <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                    <div v-for="(item, index) in showData.details" :key="index">
                        <div class="modal-title">
                            {{item.t}}
                        </div>
                        <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                            {{i}}
                        </div>
                    </div>
                </div>


                    <span class="remark">【具体课程内容以实际课程安排和进度为准】</span>
                    <button class="stage-more" @click="JumpFn">
                        <img :src="btnImg.stageMore">
                    </button>
                </div>

            </div>
        </div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index === 4" class="img" :src="item">
        </div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index > 4" class="img" :src="item">
        </div> -->


        <button class="footer" @click="JumpFn('名额有限立即抢占')">
            <img src="https://s20.lgstatic.com/growth/activity/20220712/1657612011517.png">
            <div class="iconBox" v-if="activity.isShow">
                <img class="icon" :src="activity.PCicon">
            </div>
        </button>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';

import activity from '../../../common/activity';

import List from './list'
export default {
    data() {
        return {
            activity,
            List,
            showModal:false,
            imgList:[],
            tabMain:{},
            tabImgList:[],
            btnImg:{},
            activeName:0,
            activeImgName:0,
            showData:{},
            addressIdsMap: {
                "领取完整课程安排": "s1ty8",
                "名额有限立即抢占": "t1ty9"
            }
        }
    },
    mounted () {
        setTimeout(()=>{
            // this.eduPlatTrack('WebView', { page_id: 'u1ssr'});
            this.platTrack('pcpv', {
                page_id: 'q1tyw',
            })
        },500)
        let dataList = this.List.data.pc;

        this.imgList = dataList.imgList
        this.tabImgList = dataList.tabImgList
        this.btnImg = dataList.btnImg
        this.tabMain = this.List.data.tabMain
    },
    methods: {
        JumpFn(str) {
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': 'u1ssr',
            //     'button_name': '领取详细课程大纲'
            // });
            str && this.platTrackClickFn(str);
            setTimeout(() => {
                let key = 'f331871ccf91414896e61eacd84d1429';
                handleJumpUrl(key);
            }, 200)
        },
        close() {
            this.showModal = false;
        },
        changeTab(val) {
            this.showModal = false
        },
        showModalFn(item) {
            this.showModal = true
            this.showData = item
        },
        platTrackClickFn(name) {
            this.platTrack('pcclick', {
                page_id: 'q1tyw',
                address_id: this.addressIdsMap[name]
            })
        }

    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #F1F3FF;
    padding-bottom: 118PX;

    .icon {
      width: 104PX;
      height: 133PX;
      object-fit: contain;
      position: absolute;
      top: 0;
      right: 21%;
      z-index: 9;
    }
    .section-wrap {
        background-image: linear-gradient(180deg, #4B77FF 0%, #698EFF 98%);
    }
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        .img {
            width: 100%;
            display: block;
        }
        .btn-more {
            position: absolute;
            left: 50%;
            transform: translate(-50%);
            bottom: 56PX;
            width: 464PX;
            height: 87PX;
            background-color:transparent;
            border: none;
            z-index: 9;
            cursor: pointer;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    /deep/ .el-tabs {
    width: 1060PX;
    margin: 0 auto 0PX;
    .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll {
        height: 96PX;
        border-top-left-radius: 16PX;
        border-top-right-radius: 16PX;
        // padding-left: 10PX;
        // background: linear-gradient(354deg, #412EC8 0%, #1E1C54 100%);
        background: #fff;
    }
    .el-tabs__item {
        line-height: 96PX;
        text-align: center;
        width: 140PX;
        height: 96PX;
        padding: 0;
        font-size: 22PX;
        font-family: SourceHanSansSC-Regular, SourceHanSansSC;
        color: #2B2CA8;
        font-weight: normal;

    }
    .el-tabs__nav-prev {
        top: 50%;
        color: #6389FF;
        font-weight: 500;
        font-size: 34PX;
        transform: translateY(-50%);
    }
    .el-tabs__nav-wrap.is-scrollable {
        padding: 0 35PX;
    }
    .el-tabs__nav-next {
        top: 50%;
        color: #6389FF;
        font-weight: 500;
        font-size: 34PX;
        transform: translateY(-50%);
    }
    .el-tabs__nav-wrap::after{
        background-color: transparent;
    }
    .el-tabs__active-bar {
        background-color: transparent;
    }
    .el-tabs__item.is-active {
        color: #fff;
        font-weight: bold;
        font-size: 25PX;
        background-image: linear-gradient(191deg, #6389FF 7%, #6C65FF 87%);
        border-radius: 36px;
        height: 73PX;line-height: 73PX;
    }
}
    .tab-section {
        width: 100%;
        min-width: 1200PX;
        margin: 0 0 90PX;
        padding-top: 1PX;
        .img {
            width: 642PX;
            display: block;
            margin: 0 auto;
        }
        .main {
            position: relative;
            width: 1060PX;
            margin: 0 auto;
            padding-top: 1PX;
            .tab-title-img {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width:100%;
                transform: scale(0.66);
            }
            ._tb {
            position: relative;
            width: 1060PX;
            margin: 0 auto;
            border-radius: 16PX;
            background-color: #fff;
            .m {
                width: 100%;
                box-sizing: border-box;
                padding: 0 46PX 40PX;
            }
            .m-title {
                // padding-top: 30PX;
                margin-bottom: 10PX;
                font-size: 28PX;
                font-family: SourceHanSansSC-Medium, SourceHanSansSC;
                font-weight: 400;
                color: #6469A7;
                text-align: center;
            }
            .main-icon {
                width: 688PX;
                height: 2PX;
                display: block;
                margin: 8PX auto 0;
            }
            .main-wrap {
                width: 100%;
                background-image: linear-gradient(191deg, rgba(99, 137, 255, .05) 7%, rgba(108, 101, 255, .05) 87%);
                padding: 20PX 36PX 40PX;
                box-sizing: border-box;
                border-radius: 16PX;
                margin-bottom: 60PX;
            }
            .main-t {
                width: 100%;
                height: 50PX;
                // padding-top: 35PX;
                margin-top: 20PX;
                .m-b {
                    position: relative;
                    float: left;
                    height: 46PX;
                    font-size: 24PX;
                    text-align: center;
                    line-height: 46PX;
                    border-radius: 50PX;
                    color: #0E1352;
                    padding-left: 12PX;
                    // background: linear-gradient(192deg, rgba(99, 137, 255, .1) 0%, rgba(108, 101, 255, .1) 100%);
                    &::before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 15PX;
                        width: 4PX;
                        height: 17PX;
                        background-image: linear-gradient(-41deg, #80FDFE 0%, #7EF3FE 15%, #64B1FF 97%)
                    }
                }
                .detail {
                    display: block;
                    width: 132PX;
                    height: 48PX;
                    float: right;
                }
            }
            .item {
                position: relative;
                font-size: 20PX;
                font-family: SourceHanSansSC-Light, SourceHanSansSC;
                color: #6469A7;
                margin: 10PX 20PX;
                padding-left: 15PX;
                &::after {
                    position: absolute;
                    content: '';
                    left: 0PX;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 6PX;
                    height: 6PX;
                    border-radius: 50%;
                    background: #6469A7;
                }
            }
            .item-wrap {
                display: flex;
                .left, .right {
                    width: 50%;
                }
            }
            .modal {
                position: absolute;
                top: 190PX;
                left: 50%;
                transform: translate(-50%);
                width: 1100PX;
                border-radius: 16PX;
                background-color: #fefefe;
                z-index: 999;
                border: 2PX solid #6469A7;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                .close {
                    position: absolute;
                    right: 14PX;
                    top: 14PX;
                    width: 40PX;
                    height: 40PX;
                }
                .modal-title {
                    font-size: 20PX;
                    padding:35PX 0 10PX;
                    color: #6469A7;
                }
                .modal-desc {
                    font-size: 18PX;
                    color: #6469A7;
                    padding-left: 18PX;
                }
            }
            .jump-btn {
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                bottom: -34PX;
                width: 341PX;
                height: 68PX;
                background-color:transparent;
                border: none;
                img {
                    width: 100%;
                    display: block;
                }
            }
        }
            .stage-more {
                position: absolute;
                bottom: -40PX;
                left: 50%;
                transform: translate(-50%);
                width: 380PX;
                background-color:transparent;
                border: none;
                z-index: 9;
                cursor: pointer;
                img {
                    width: 100%;
                    display: block;
                }
            }
            .remark {
              width: 280PX;
              height: 20PX;
              line-height: 20PX;
              font-size: 14PX;
              position: absolute;
              bottom: 60PX;
              left: 50%;
              transform: translateX(-50%);
              opacity: .4;
              color: #878AB0;
            }
            .modal {
                position: absolute;
                top: 260PX;
                left: 50%;
                transform: translate(-50%);
                width: 800PX;
                border-radius: 16PX;
                background-color: #fefefe;
                z-index: 999;
                border: 2PX solid #6469A7;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                .close {
                    position: absolute;
                    right: 14PX;
                    top: 14PX;
                    width: 40PX;
                    height: 40PX;
                }
                .modal-title {
                    font-size: 20PX;
                    padding:35PX 0 10PX;
                    color: #6469A7;
                }
                .modal-desc {
                    font-size: 14PX;
                    color: #6469A7;
                    padding-left: 18PX;
                }
            }
        }

    }
    .tab-img-section {
        width: 100%;
        min-width: 1200PX;
        margin: 40PX 0 0PX;
        padding-top: 1PX;
        .main {
            position: relative;
            width: 1060PX;
            margin: 0 auto;
            padding-top: 1PX;
            ._tb {
                position: relative;
                margin: 0PX auto 0;
                width: 1000PX;
                background-color: #fff;
                box-sizing: border-box;
                border-radius: 30PX;
                padding-bottom: 30PX;
                border-top-left-radius: 0PX;
                /deep/ .el-tabs {
                    width: 100%;
                    .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
                        height: 66PX;
                        background-color: rgba(26, 29, 60, 1);
                        border-top-right-radius: 30PX;
                    }
                    .el-tabs__item {
                        line-height: 66PX;
                        text-align: center;
                        width: 250PX;
                        height: 66PX;
                        padding: 0;
                        font-size: 24PX;
                        font-family: SourceHanSansSC-Bold, SourceHanSansSC;
                        font-weight: 400;
                        color: #fff;
                        background: url('https://s21.lgstatic.com/growth/activity/20210422/1619075679017.png') no-repeat center;
                        background-size: 100% 100%;
                        border-top-right-radius: 30PX;
                    }
                    .el-tabs__nav-wrap::after{
                        background-color: transparent;
                    }
                    .el-tabs__active-bar {
                        background-color: transparent;
                    }
                    .el-tabs__item.is-active {
                        padding: 0;
                        background: #fff;
                        color: #34397D;
                    }
                }
                .m-img {
                    width: 100%;
                    img {
                        display: block;
                        width: 100%;
                    }
                }
                .btn-receive {
                    position: absolute;
                    bottom: -50PX;
                    left: 50%;
                    transform: translate(-50%);
                    width: 448PX;
                    height: 20px;
                    background-color:transparent;
                    border: none;
                    z-index: 9;
                    img {
                        width: 100%;
                        display: block;
                    }
                }
            }
        }
        @media screen and (max-width:1600px){
            .main {
                width: 900PX;
                ._tb {
                    width: 860PX;
                    /deep/ .el-tabs {
                        .el-tabs__item {
                            width: 215PX;
                        }
                    }
                }
            }

        }
    }
    .tab-fill {
        width: 100%;
        height: 250PX;
        background-color: rgba(33, 52, 110, 1);
        margin-top: -100PX;
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        width: 100%;
        cursor: pointer;
        box-shadow:0PX 15PX 10PX 15PX #ccc;
        img {
            width: 100%;
            display: block;
        }
        .iconBox {
            position: absolute;
            top: -60PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 1640PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
    }
}

</style>
